<div class="table-row">
    <div id="toggler" class="row py-2 align-items-center" (click)="toggleExpandEvent.emit()">
        <div class="col-1 limited-col-width">
            <fa-icon [icon]="isExpanded ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        <div class="col-7">
            <span *ngIf="address.name1.value">{{ address.name1.value }}</span>
            <span *ngIf="!address.name1.value">{{ address.addrText.value }}</span>
        </div>
        <div class="col">{{ address.city.value }}</div>
    </div>
    <div *ngIf="isExpanded" class="py-3">
        <div class="row align-items-center">
            <form *ngIf="addressFormGroup" [formGroup]="addressFormGroup">
                <fieldset [disabled]="!isEditable">
                    <div class="row mb-3">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-text-input
                                [model]="displayAddressText"
                                (modelChange)="selectedAddress.addrText = $event"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onAddressChange()"
                                [ariaLabel]="'TIMESHEET_ADDRESS_TEXT' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_STREET_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-text-input
                                [(model)]="selectedAddress.street"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onAddressChange()"
                                [ariaLabel]="'TIMESHEET_ADDRESS_STREET_TEXT' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_POSTCODE_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-text-input
                                [(model)]="selectedAddress.postCode"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onAddressChange()"
                                [ariaLabel]="'TIMESHEET_ADDRESS_POSTCODE_TEXT' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_CITY_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-text-input
                                [(model)]="selectedAddress.city"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onAddressChange()"
                                [ariaLabel]="'TIMESHEET_ADDRESS_CITY_TEXT' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_COUNTRY_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-text-input
                                [(model)]="selectedAddress.country"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onAddressChange()"
                                [ariaLabel]="'TIMESHEET_ADDRESS_COUNTRY_TEXT' | translate"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="row mb-3" *ngIf="selectedAddress.statesOfUSA">
                        <label
                            class="col-12 col-md-3 col-form-label text-start text-md-end"
                            translate="TIMESHEET_ADDRESS_STATES_OF_USA_TEXT"
                        ></label>
                        <div class="col-12 col-md-8">
                            <pace-core-dropdown
                                [(model)]="selectedAddress.statesOfUSA"
                                [parentForm]="addressFormChildren"
                                (valueChange)="onStateChange()"
                            ></pace-core-dropdown>
                        </div>
                    </div>
                </fieldset>
            </form>
            <div class="col-auto ms-auto">
                <button
                    class="btn btn-light me-3"
                    *ngIf="(enableHideTimesheetAddress && address.allowToHide) || !address.addrNumber.value"
                    (click)="openHelp()"
                    [attr.aria-label]="'TIMESHEET_ADDRESS_HELP_BUTTON_LABEL' | translate"
                >
                    <fa-icon [icon]="faQuestion"></fa-icon>
                </button>
                <button
                    class="btn btn-warning me-2"
                    *ngIf="enableHideTimesheetAddress && address.allowToHide"
                    (click)="hideAddress()"
                    [attr.aria-label]="'TIMESHEET_ADDRESS_HIDE_ADDRESS_BUTTON_LABEL' | translate"
                >
                    <fa-icon [icon]="faEyeSlash"></fa-icon>
                </button>
                <button
                    class="btn btn-warning me-2"
                    *ngIf="!address.addrNumber.value"
                    (click)="deleteAddress()"
                    [attr.aria-label]="'TIMESHEET_ADDRESS_DELETE_ADDRESS_BUTTON_LABEL' | translate"
                >
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
                <button
                    class="btn btn-primary"
                    type="button"
                    [disabled]="isEditable && !addressFormGroup.valid"
                    (click)="selectAddress()"
                    translate="TIMESHEET_SELECT_ADDRESS_LABEL"
                ></button>
            </div>
        </div>
    </div>
</div>
